<!-- 任务类型设置 --- 任务操作设置 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"100",
        name:"用户角色管理",
        parentId:"USER_ID",
        parentName:"用户管理",
        parentPath:"/system/userManagement",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:2,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>

<style></style>